/** Persisted feature map from /auth/me — used so sidebar respects Super Admin toggles after refresh. */
export const FEATURE_FLAGS_STORAGE_KEY = 'erp_feature_flags_v1';

/** Persisted role-based feature permissions from /auth/me — controls in-page actions and sidebar visibility per role. */
export const ROLE_FEATURES_STORAGE_KEY = 'erp_role_features_v1';
